import { Asset } from '../asset'

const updateAllowedProps = [
  'asset',
  'description',
]

class Logo {
  constructor(options = {}) {
    options = options || {}
    this.asset = Asset.init(options.asset)
    this.description = options.description
  }

  // Class methods
  static init(options) {
    if (options instanceof Logo) {
      return options
    }
    const instance = new Logo(options)
    return instance.isValid ? instance : null
  }
  static initFromArray(arr) {
    if (Array.isArray(arr)) {
      return arr.map(this.init)
    }
    return []
  }
  static initOnlyValidFromArray(arr = []) {
    return this.initFromArray(arr).filter((i) => i)
  }

  // getters
  get isValid() {
    return !!this
  }

  getAssetFullPath() {
    return this.asset ? this.asset.fullPath : null
  }
  setAssetFullPath(url) {
    if (this.asset) {
      this.asset.fullPath = url
      this.asset.timestamp = (new Date()).valueOf()
    }
    return this
  }

  updateLogo(update) {
    Object.keys(update).forEach((key) => {
      if (updateAllowedProps.includes(key)) {
        if (key === 'asset') {
          this.asset.updateAsset(update[key])
        } else {
          this[key] = update[key]
        }
      }
    })
    return this
  }
}

export default {
  Logo
}
export {
  Logo
}
